import React, { useRef, useState } from "react";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { updateQrCode, updateInfo } from "store/actions/authActions";

const QRCodeCard = ({
  user,
  uid,
  dispatch,
  qrCodeLoading,
  qrUrl,
  setQrUrl,
  fields,
  fieldToggle,
  modalToggle,
}) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [qrPreview, setQrPreview] = useState(null);

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;
    if (file.size <= 1000000) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setQrPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      toast.error("File size exceeds 1MB");
    }
  };

  const handleUpload = (e) => {
    e.preventDefault();
    if (!selectedFile) return;
    let obj = {
      qrCode: selectedFile,
      fileName: user?.qrCode?.file_name || "qr_code",
    };
    dispatch(updateQrCode(obj, uid)).then(() => {
      setSelectedFile(null);
      setQrPreview(null);
    });
  };

  const handleUpdateUrl = (e) => {
    e.preventDefault();
    const regex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/)|you\.tube\/(watch\?v=|embed\/|v\/)?|youtu\.be\/)[a-zA-Z0-9_-]{11}/;
    if (regex.test(qrUrl)) {
      dispatch(updateInfo(uid, qrUrl, "Qr_Url")).then(() => {
        fieldToggle("qrUrlEdit");
      });
    } else {
      toast.warning("Invalid YouTube URL. Please enter a valid link.");
    }
  };

  const triggerFileSelect = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="saas-card">
      <div className="card-header-saas">
        <h3>QR Code Setup</h3>
        <button
          className="saas-btn secondary sm"
          onClick={() => modalToggle("AthleteInstructions")}
        >
          Instructions
        </button>
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: "20px", alignItems: "center", marginBottom: "16px" }}>
          {qrPreview || user?.qrCode?.url ? (
            <img
              src={qrPreview || user.qrCode.url}
              style={{ width: "90px", height: "90px", borderRadius: "8px", border: "1px solid #cbd5e1" }}
              alt="QR Code preview"
            />
          ) : (
            <div style={{ width: "90px", height: "90px", borderRadius: "8px", border: "2px dashed #cbd5e1", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.75rem", color: "#64748b", textAlign: "center", padding: "4px" }}>
              Upload QR Code
            </div>
          )}
          <div style={{ fontSize: "0.8125rem", color: "#64748b" }}>
            {selectedFile ? (
              <span className="text-success font-weight-bold">
                <i className="fas fa-check-circle mr-1"></i> QR Code ready for upload.
              </span>
            ) : (
              "Upload your personal QR Code image. Format: JPEG, PNG. Max size: 1MB."
            )}
          </div>
        </div>

        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
          accept="image/png, image/gif, image/jpeg"
        />

        <div className="upload-zone" onClick={triggerFileSelect}>
          <i className="fas fa-qrcode"></i>
          {selectedFile ? (
            <p>Selected: <span>{selectedFile.name}</span></p>
          ) : (
            <p>Drag & Drop or <span>Browse files</span></p>
          )}
        </div>

        {/* QR URL input */}
        <div className="info-row" style={{ borderTop: "1px solid #f1f5f9", paddingTop: "16px", marginBottom: "16px" }}>
          <span className="info-label">QR Redirect Link</span>
          {fields.qrUrlEdit ? (
            <form onSubmit={handleUpdateUrl} style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '70%' }}>
              <input
                required
                className="saas-input"
                type="text"
                placeholder="Enter YouTube Link"
                value={qrUrl}
                onChange={(e) => setQrUrl(e.target.value)}
                style={{ height: '32px', borderRadius: '6px', fontSize: '0.8125rem', flex: 1 }}
              />
              <button type="submit" className="saas-btn primary sm">Save</button>
              <button type="button" className="saas-btn secondary sm" onClick={() => fieldToggle("qrUrlEdit")}>Cancel</button>
            </form>
          ) : (
            <span className="info-value" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px", width: "100%" }}>
              <span className="text-truncate d-inline-block" style={{ maxWidth: '180px' }}>
                {user?.Qr_Url || "Add Link"}
              </span>
              <button className="saas-btn secondary sm" style={{ height: '22px', fontSize: '0.7rem', padding: '0 8px' }} onClick={() => fieldToggle("qrUrlEdit")}>Edit</button>
            </span>
          )}
        </div>

        <button
          className="saas-btn primary w-100"
          onClick={handleUpload}
          disabled={!selectedFile || qrCodeLoading}
        >
          {qrCodeLoading ? <Spinner size="sm" /> : "Update QR Code"}
        </button>
      </div>
    </div>
  );
};

export default QRCodeCard;
